import { SubmitReportMatchScoreBugsRequest } from "@type/report";
import { getCookie } from "@util/cookie";
import axios from "axios";

const apiURL = import.meta.env.VITE_TALENT_AI_BE_BASE_URL;

export async function submitReportMatchScoreBugs(data: SubmitReportMatchScoreBugsRequest): Promise<any> {
    const token = getCookie("authToken");
    return await axios({
        url: `${apiURL}/report/bugs`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        data,
    });
}
